<h2 mat-dialog-title class="help-title">
  <span class="help-title-text">
    <mat-icon class="help-title-icon">help_outline</mat-icon>
    <span>Systemhilfe {{ getSiteName(contentRoute) }}</span>
  </span>
  <button mat-icon-button mat-dialog-close class="help-close" aria-label="Schließen">
    <mat-icon>close</mat-icon>
  </button>
</h2>
<mat-dialog-content class="help-content">
  @if (search === true) {
    <mat-form-field class="input-full-width help-search" appearance="outline">
      <mat-label>Hilfe durchsuchen</mat-label>
      <mat-icon matPrefix>search</mat-icon>
      <input matInput [matAutocomplete]="auto" [formControl]="searchControl" />
      <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="setHelpEntry($event.option.value.path)">
        @for (option of filteredSites | async; track option) {
          <mat-option [value]="option"> {{ option.name }} </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  }
  <div class="help-body">
    @switch (contentRoute) {
      @case ('/home') {
        <app-help-home [parent]="this"></app-help-home>
      }
      @case ('/user') {
        <app-help-user [parent]="this"></app-help-user>
      }
      @case ('/responder') {
        <app-help-responder [parent]="this"></app-help-responder>
      }
      @case ('/evd') {
        <app-help-evd [parent]="this"></app-help-evd>
      }
      @case ('/alarms') {
        <app-help-alarms [parent]="this"></app-help-alarms>
      }
      @case ('/guards') {
        <app-help-guards [parent]="this"></app-help-guards>
      }
      @case ('/event') {
        <app-help-events [parent]="this"></app-help-events>
      }
      @case ('/profile') {
        <app-help-profile [parent]="this"></app-help-profile>
      }
      @case ('/settings') {
        <app-help-settings [parent]="this"></app-help-settings>
      }
      @case ('/statistics') {
        <app-help-statistics></app-help-statistics>
      }
      @default {
        <div class="tile-grid">
          @for (tile of helpTiles; track tile.route) {
            <button type="button" class="tile" (click)="setHelpEntry(tile.route)">
              <mat-icon class="tile-icon">{{ tile.icon }}</mat-icon>
              <span class="tile-label">{{ tile.label }}</span>
              <mat-icon class="tile-chevron">chevron_right</mat-icon>
            </button>
          }
        </div>
      }
    }
  </div>
</mat-dialog-content>
@if (search === false) {
  <mat-dialog-actions>
    <button mat-stroked-button color="primary" (click)="helpOverview()">
      <mat-icon>arrow_back</mat-icon>
      Zur Übersicht
    </button>
  </mat-dialog-actions>
}
